'use client';

import { ToastContainer } from 'react-toastify';

export default function () {
  return (
    <ToastContainer
      toastClassName={(props) =>
        ({
          success: 'bg-success',
          error: 'bg-error text-greyscale-offwhite',
          info: 'bg-warning-light text-warning-dark',
          warning: 'bg-warning-light text-warning-dark',
          default: 'bg-primary',
          dark: 'bg-white-600 font-gray-300',
        }[props?.type || 'default'] +
        ' relative flex items-center p-4 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer')
      }
      closeOnClick
      draggable
      hideProgressBar={false}
      pauseOnFocusLoss={false}
      autoClose={3000}
      newestOnTop
      position={'top-right'}
      theme={'colored'}
    />
  );
}
